export var API_CONFIG = {
  URL: '/webservices/hearingtest.svc/'
};
export var REDIRECTS = {
  CONFIRMATION_URL: 'http://hearingsolutions.preview.test.cas.dgs.com/design-guide/hearing-test-invitation',
  HEARING_TEST_URL: 'http://hearingsolutions.preview.test.cas.dgs.com/hearing-loss/hearing-test'
};